import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";


export const useUploadedFiles = (url, enabled = true) => {
    return useQuery({
        queryKey: [`uploaded_files__${url}`],
        queryFn: async () => getData(url),
        enabled: enabled
    })
}